import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-397478f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logos/Logo_Bouwrisk.svg",
    height: "30"
  })
], -1))

import { onMounted, ref, watch } from 'vue'
import { CameraOutlined, LogoutOutlined, MailOutlined, MenuOutlined } from '@ant-design/icons-vue'
import { authStore } from '@/stores/auth'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileNavigation',
  setup(__props) {

const showNavigationDrawer = ref(false)

const selectedKeys = ref<string[]>([])
const route = useRoute()
const router = useRouter()

watch(() => route.name, () => {
  setActiveRoute()
})

onMounted(() => {
  setActiveRoute()
})

function setActiveRoute () : void {
  if (typeof route.name === 'string') {
    switch (route.name) {
      default:
        selectedKeys.value = [route.name]
        break
    }
  }
}

function navigateTo (navItem:{ key:string }) : void {
  if (route.name !== navItem.key && navItem.key !== 'Logout') {
    const keyboard = window.event as KeyboardEvent
    if (keyboard.ctrlKey) {
      const route = router.resolve({ name: navItem.key })
      window.open(route.href, '_blank')
    } else {
      router.push({ name: navItem.key })
    }
  }
  showNavigationDrawer.value = !showNavigationDrawer.value
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(MenuOutlined), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showNavigationDrawer.value = !showNavigationDrawer.value))
      })
    ]),
    _hoisted_2,
    _createVNode(_component_a_drawer, {
      title: "Navigatie",
      placement: "left",
      width: "75%",
      "body-style": { padding: 0 },
      visible: showNavigationDrawer.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (showNavigationDrawer.value = !showNavigationDrawer.value))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_menu, {
          class: "desktop-navigation",
          mode: "inline",
          selectedKeys: selectedKeys.value,
          "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
          onClick: navigateTo
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "Dashboard" }, {
              icon: _withCtx(() => [
                _createVNode(_unref(CameraOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Mijn opname ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "ContactDetails" }, {
              icon: _withCtx(() => [
                _createVNode(_unref(MailOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Mijn contactgegevens ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "Logout",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(authStore)().logout()), ["stop"]))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(LogoutOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Uitloggen ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selectedKeys"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})